import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import Login from 'components/molecules/Login';
import appConfig from 'helper/mapBackendConfig';
import { LinkSchema } from 'helper/mapBackendConfig';
import { actionCreators as loginAC, getIsMigrosAuthenticated, getLoginRedirectRoutePath } from 'store/login';
import { getUserData } from 'store/profile';
import { IRootState } from 'store/rootReducer';
import { getCurrentViewID } from 'store/view';
import { getMigrosLoginReturnToURL, getMigrosLogoutReturnToURL } from '../../helper/login';

export type StateToPropsType = {
	activeViewId: string | null;
	userData: Object | null;
	isMigrosAuthenticated: boolean;
	impulsCoachBaseLink: LinkSchema;
	migrosLoginReturnToURL: string;
	migrosLogoutReturnToURL: string;
};

const mapStateToProps = (state: IRootState): StateToPropsType => ({
	activeViewId: getCurrentViewID(state),
	userData: getUserData(state),
	isMigrosAuthenticated: getIsMigrosAuthenticated(state),
	impulsCoachBaseLink: appConfig.env.migrosImpulsCoachLandingPage,
	migrosLoginReturnToURL: getMigrosLoginReturnToURL(getLoginRedirectRoutePath(state)),
	migrosLogoutReturnToURL: getMigrosLogoutReturnToURL(),
});

const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators(
		{
			doChangeMigrosLoginStatus: loginAC.doChangeMigrosLoginStatus,
			doClearRedirectRoutePath: loginAC.doClearRedirectRoutePath,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(Login as any);
